// Module
var code = `<div class="struct-list"></div>`;
// Exports
export default code;